import { ButtonSize, ButtonStyles, Theme, useTranslation, useNextgenRouter } from '@nextgen-web-framework/all';
import { ErrorCard, getLoginProps, type ErrorCardProps } from '@commerce-webcomponents/ui';
import { LoginButton } from '@commerce-identity-webcomponents/ui';

type ErrorCardWithLoginProps = ErrorCardProps;
const ErrorCardWithLogin = (props: ErrorCardWithLoginProps) => {
  const router = useNextgenRouter();
  const t = useTranslation();
  const loginBtn = (
    <LoginButton
      theme={Theme.BLACK}
      buttonStyle={ButtonStyles.SOLID}
      size={ButtonSize.MEDIUM}
      title={t('web.error.button.restricted')}
      {...getLoginProps(router.params?.locale as string)}
    />
  );

  return <ErrorCard {...props} restrictedButton={loginBtn} />;
};

export default ErrorCardWithLogin;
export { ErrorCardWithLoginProps };
